"use client";
import { PROMOTION_CODE_PAYMENT } from "@/app/env";
import axios from "axios";
import { Spinner } from "flowbite-react";
import { useParams } from "next/navigation";
import React, { useEffect, useState } from "react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslations } from "next-intl";
function PromoCode({
  onSuccess,
  courseType,
  color = "#52A8F2",
}: {
  onSuccess: (price: number | undefined, code: string | null) => void;
  color?: string;
  courseType?: number;
}) {
  const { courseId } = useParams();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const reset=()=>{
    setCode('')
    setLoading(false)
    setIsSuccess(false)
    setIsError(false)
    onSuccess(undefined, null);
  }
  useEffect(()=>{
    reset()
  },[courseType])

  const handlePromoCode = (value: string) => {
    setIsError(false);
    setIsSuccess(false);
    onSuccess(undefined, null);
    if (value) {
      setLoading(true);
      axios
        .get(PROMOTION_CODE_PAYMENT, {
          params: {
            code: value,
            courseId,
            courseType 
          },
        })
        .then((data) => {
          setLoading(false);

          if (data?.data > 0) {
            setIsSuccess(true);
            onSuccess(data.data, value);
            return;
          } else {
            setIsError(true);
          }
        })
        .catch(() => {
          setLoading(false);
          setIsError(true);
        });
    }
  };
  const t = useTranslations("contactUs.form");

  return (
    <div className="flex w-full  ">
      <label className="lg:text-[1.5rem] lg:flex hidden lg:!w-[20rem] w-[203px] lg:mt-[.4rem] text-[14px] text-[#220859] font-light">
        {t("promoCode")}
      </label>
      <div
        style={{ borderColor: isError ? "red" : isSuccess ? "green" : color }}
        className="border-secondary  h flex lg:ps-[1.875rem] w-full mb-[20px] lg:mb-[19px] lg:text-[1.25rem] font-medium  text-[12px] bg-[#FAFAFA] px-[4px] lg:px-[5px] py-[4px] lg:py-[5px] shadow-select border-[1px] rounded-[30px]"
      >
        <input
          value={code}
          style={{ color: isError ? "red" : isSuccess ? "green" : "" }}
          onChange={(e) => {
            setCode(e.target.value)
            setIsError(false)
            setIsSuccess(false)
            onSuccess(undefined, null);
          }}
          className="flex-1 bg-transparent  border-none focus:outline-none h-full shadow-none  font-bold text-[12px] lg:text-[1.25rem] "
        ></input>
        <div
          onClick={() => handlePromoCode(code)}
          style={{
            backgroundColor: isError ? "red" : isSuccess ? "green" : color,
          }}
          className="lg:h-[2.5rem] cursor-pointer h-[22px] w-[59px] flex justify-center items-center rounded-full lg:w-[7.5rem] bg-secondary text-white lg:text-[1.24rem] font-medium text-[12px]"
        >
          {loading ? (
            <Spinner size="md" color="" />
          ) : isSuccess ? (
            <FontAwesomeIcon className="" size="1x" icon={faCheck} />
          ) : (
            t("apply")
          )}
        </div>
      </div>
    </div>
  );
}

export default PromoCode;
